export const UPDATE_BRAND_FUNCTIONS_STATE = 'UPDATE_BRAND_FUNCTIONS_STATE'
export const BRAND_FUNCTION_CREATED = 'BRAND_FUNCTION_CREATED'



// WEBPACK FOOTER //
// ./src/data/redux/brand_function_details/actiontypes.js